import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class EmployerUserType {
  public readonly key = 'EmployerUserType';
  public readonly enrollTrackRole = EnrollTrackRole.Employer;
}
